<template>
	<div>
		<ed-form :data="formData" :config="config" :response="response" :itens="exameItems" v-loading="this.config.loading.content">
			<div slot="form-footer">
			</div>
			<div slot="form-end">
				<ed-button 
					type="warning" 
					value="Gerar Documento"
					icon="fa fa-file-word-o"
					title="Clique aqui para gerar o LTCAT no formato .DOC"
					@click="gerarDocumento"
				/>

				<div class="col-12 text-left mt-3" v-if="formData.id>0">

					<el-tabs type="border-card" v-model="tagConfig">
						<el-tab-pane label="Config" name="tab-ghe">
							<span slot="label">
								<i class="fa fa-building"></i> Setores
							</span>
							<LtcatGhe :ltcat="formData"/>
						</el-tab-pane>

						<el-tab-pane label="Config" name="tab-docs" v-if="this.validarPermissao(576)">
							<span slot="label">
								<i class="fa fa-file-image-o"></i> Documentos e Anexos
							</span>
							<LtcatAnexo :ltcat="formData"/>
						</el-tab-pane>

						<el-tab-pane label="Config" name="tab-orcamento" v-if="this.validarPermissao(577)">
							<span slot="label">
								<i class="fa fa-usd"></i> Orçamentos
							</span>
							<LtcatOrcamento :ltcat="formData"/>
						</el-tab-pane>

					</el-tabs>
					
				</div>
			</div>
		</ed-form>

	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdButton from 'common/button';
	import FormItems  from './_form/ltcat-editar';
	import LtcatGhe from './ghe/index'
	import LtcatAnexo from './anexo/index'
	import LtcatOrcamento from './orcamento/index'


  	export default {
  		name:"ltcat-risco-cadastrar",
  		components: {EdForm,EdButton,LtcatGhe,LtcatAnexo,LtcatOrcamento},
		mixins:[Rest],
		watch: {
			'formData.id_emp'(){
			},
			'formData.id_fdt'(){
			},
			'formData.id_rev'(){
			},
			'formData.id'(){
				this.handlerDisableYesterdayDate();
				this.config.disabled.id_tipo_revisao = (this.formData.id_tipo_revisao == 2);
			}
		},
  		data () {
		   	return {
				config:{
					tipo:[1,203],
					tipo_exclude:[],
					hidden:{
						ppra:false,
						id_rev:true
					},
					title:{
						ppra:''
					},
					disabled:{
						id_emp:true,
						id_fdt:true,
						id_tipo_ltcat:true,
						id_tipo_revisao:false,
							id_rev:true
					},
					click:{
						save:this.salvar,
						id_emp:this.getEmpresa,
						id_fdt:this.getFdt,
						id_rev:this.getRevisaoLtcat,
						id_res:this.getProfissionais,
						id_mod:this.getModelo
					},
					list:{
						id_emp:[],
						id_fdt:[],
						id_rev:[],
						id_res:[],
						id_mod:[],
					},
					change:{
						id_rev:this.getLtcat
					},
					loading:{
						save:false,
						id_emp:false,
						id_fdt:false,
						id_rev:false,
						id_res:false,
						id_mod:false,
					},
					title:{
						id_emp: 'Editar Cadastro',
					},
					options:{
						data:{
							disabledDate:this.handlerDisableYesterdayDate
						}
					}
				},
		   		formData:{
					id:0,
					id_tipo_revisao:null,
					id_emp:null,
					id_rev:null,
					id_fdt:null,
					id_rev:null,
					id_res:null,
					obs:null,
					data:null,
					usuario:null,
					empresa:null,
					ppra:0,
		   		},
				response:{},
				exameItems:[],
				tagConfig:'tab-ghe'
			}
		},

		mounted() {
			this.exameItems = FormItems;
			this.getLtcat();
			this.getModelo();
		},

		methods: {

			gerarDocumento(){
				if(this.formData.id == 0)return;

				if(!this.formData.id_mod){
					this.edAlert('Selecione um modelo e o responsável pelo LTCAT','error');
					return;
				}

				window.open(this.env.url_cs+'/app/ltcat_gera.php?p='+this.base64Encode(this.formData.id),'blank')
			},

			getLtcat(id){

				this.config.loading.content = true;
				
				id = (id ? id : this.$route.params.id);
				
				this.get('ltcat/'+id).then((result)=>{
					result = result[0];
					
					this.config.loading.content = false;

					let revisao = '555';

					if(result.data.revisao){
						revisao = (
							(
								result.data.revisao.parent ? 
								result.data.revisao.parent.rev+' ('+result.data.revisao.parent.descricao+' em '+result.data.revisao.parent.descricao+') / '
								: ''
							)+
							result.data.revisao.rev+' ('+result.data.revisao.descricao+' em '+result.data.revisao.descricao+')'
						)
					}
					if(result.status == 200){
						this.formData = {
							id: result.data.id,
							id_rev: result.data.id,
							id_tipo_revisao:result.data.id_tipo_revisao,
							id_emp:result.data.empresa.id,
							id_fdt:result.data.fdt.id,
							id_res:(result.data.responsavel ? result.data.responsavel.id : null),
							id_mod:(result.data.modelo ? result.data.modelo.id : null),
							rev:result.data.rev,
							obs:result.data.obs,
							empresa:result.data.empresa,
							id_tipo_ltcat: result.data.id_tipo_ltcat,
							id_rev:revisao,
							revisao:result.data,
							data:this.toDate(result.data.data,true),
						};

						this.config.list.id_emp = [result.data.empresa];
						this.$store.dispatch("ltcat/setLtcat", this.formData);
						
						if(result.data.id_tipo_ltcat == 205){
							this.config.hidden.id_rev = false
						}

						this.getFdt();
						this.getRevisaoLtcat();
						this.getProfissionais();
					}
					else{
						this.$router.push({name:'ltcat'});
					}
				});
			},

			getEmpresa(){

				if(!this.formData.id_emp)return;

				window.open(this.env.url_cs+'app/empresas_info.php?abre='+this.formData.id_emp,'blank')
			},

			getModelo(search){

				this.config.loading.id_mod = true;
				this.config.list.id_mod = [];

				
				this.get('/ltcat/modelo',{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_mod = false;

					if(result.status == 200){
						this.config.list.id_mod = result.data.data;
					}
				});
			},

			getProfissionais(search){

				this.config.loading.id_res = true;
				this.config.list.id_res = [];

				this.formData.empresa.id_eng.push(0);
				this.formData.empresa.id_tec.push(0);

				var filter = {
					ids:[],
					profissionais:[0,1,2]
				}

				for (let index = 0; index < this.formData.empresa.id_eng.length; index++) {
					const element = this.formData.empresa.id_eng[index];
					filter.ids.push(element)
				}

				for (let index = 0; index < this.formData.empresa.id_med.length; index++) {
					const element = this.formData.empresa.id_med[index];
					filter.ids.push(element)
				}

				for (let index = 0; index < this.formData.empresa.id_tec.length; index++) {
					const element = this.formData.empresa.id_tec[index];
					filter.ids.push(element)
				}

				console.log('asdf',filter)
				this.get('/profissionais/-1',{search:search,filter:filter}).then((result)=>{
					result = result[0];

					this.config.loading.id_res = false;

					if(result.status == 200){
						this.config.list.id_res = result.data.data;
					}
				});
			},


			getFdt(search){

				if(!this.formData.id_emp || this.config.list.id_fdt.length>0)return;

				this.config.loading.id_fdt = true;
				this.config.list.id_fdt = [];
				
				this.get('/pcmso/fdt/'+this.formData.id_emp,{search:search}).then((result)=>{
					result = result[0];

					this.config.loading.id_fdt = false;

					if(result.status == 200){
						this.config.list.id_fdt = result.data.data;
					}
				});
			},

			getRevisaoLtcat(){

				if(!this.formData.id_emp || !this.formData.id_fdt || this.config.list.id_rev.length>0)return;

				this.config.loading.id_rev = true;
				this.config.list.id_rev = [];

				var filter = {
					id_empresa:this.formData.id_emp 
				}
				
				this.get('/ltcat',{filter:filter}).then((result)=>{
					result = result[0];

					this.config.loading.id_rev = false;

					if(result.status == 200){
						this.config.list.id_rev = this.formataRevisao(result.data.data);
					}

				});
			},

			handlerDisableYesterdayDate(date){

				if(this.config.list.id_rev.length == 0)return false;

				var primeira_revisao = this.config.list.id_rev[0];

				var hoje = (primeira_revisao.parent ? primeira_revisao.parent.data : primeira_revisao.data);
				date = this.toDate(date,true,'YYYY-MM-DD');
				
				return date < hoje;
			},

			salvar(){

				this.response = {};
				this.config.loading.save = true;

				this.post('ltcat/editar',this.formData).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?118a0227